export default {
    prioritySelects: ['Normal', 'Important', 'Urgent'],
    statusSelects: ['Not Started', 'In Progress', 'Completed', 'Deferred']
}